module.exports = __webpack_public_path__ + "img/hot_zc.ffbe4ed1.svg";